import Zcon, { createPrefixIcon } from "./Zcon";

export { createPrefixIcon };
export default Zcon;
